import type { RefObject } from 'react';
import ModalPortal from '@alltrails/core/components/ModalPortal';
import styles from './ThreeDSecureContainer.module.scss';

type Props = {
  containerRef: RefObject<HTMLDivElement | null>;
};

export function showThreeDSecureContainer(container: HTMLElement) {
  container.classList.add(styles.threeDSecureContainerVisible);
}

export function hideThreeDSecureContainer(container: HTMLElement) {
  container.classList.remove(styles.threeDSecureContainerVisible);
}

export default function ThreeDSecureContainer({ containerRef }: Props) {
  return (
    <ModalPortal>
      <div className={styles.threeDSecureContainer} ref={containerRef} />
    </ModalPortal>
  );
}
